import api from './client';

export const supplierAuthApi = {
  getMe: () => api.get('/api/supplier-auth/me'),
};
